module.exports = __webpack_public_path__ + "img/nacex.fd3362d2.png";